import { Injectable } from '@angular/core';
import { AppMetadataApiService, ListApplicationsResp } from '@xpo-ltl/sdk-appmetadata';
import { XpoAppSwitcherApplication } from '@xpo-ltl/ngx-ltl-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { map as _map } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class XpoLtlAppSwitcherService {
  constructor(private appMetadataApi: AppMetadataApiService) {}

  getAppList(): Observable<XpoAppSwitcherApplication[]> {
    return this.appMetadataApi.listApplications().pipe(
      map((resp: ListApplicationsResp) => {
        return _map(resp.applications, (app) => {
          const xpoApp: XpoAppSwitcherApplication = {} as XpoAppSwitcherApplication;
          xpoApp.name = app.applName;
          xpoApp.url = app.url;
          return xpoApp;
        });
      })
    );
  }
}
